module.exports = __webpack_public_path__ + "img/jxz.25b52884.png";